import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "../modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";

@Component({
  selector: 'app-modal-view-police-details',
  templateUrl: './modal-view-police-details.component.html',
  styleUrls: ['./modal-view-police-details.component.scss']
})
export class ModalViewPoliceDetailsComponent implements OnInit {

  busyGet: Subscription;
  filiale_id: any;
  user: any = {};
  currentData: any;
  modalRef: BsModalRef;
  itemPolice: any = {};
  itemsFiliale: any;

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
  ) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id;
    console.log("this.currentData: ", this.currentData);
    setTimeout(() => {
      if (this.currentData) {
        this.getItemPolice(this.currentData.id);
      }
    }, 50);
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {}
      );
  }

  getItemPolice(police_id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        id: police_id,
      },
    };

    this.busyGet = this.restClient
      .post("police/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemPolice = res["items"][0];
            this.itemPolice.date_effet = moment(this.itemPolice.date_effet).format('DD/MM/YYYY')
            this.itemPolice.date_echeance = moment(this.itemPolice.date_echeance).format('DD/MM/YYYY')
            this.itemPolice.souscripteur_libelle = this.itemPolice.souscripteur_nom? this.itemPolice.souscripteur_nom+' '+this.itemPolice.souscripteur_prenom : this.itemPolice.souscripteur_libelle
            this.itemPolice.courtier_libelle = this.itemPolice.courtier_nom? this.itemPolice.courtier_nom+' '+this.itemPolice.courtier_prenom : this.itemPolice.courtier_libelle
            this.itemPolice.commerciale = this.itemPolice.commerciale_nom+' '+this.itemPolice.commerciale_prenom

          } else {
            this.itemPolice = {};
          }
        },
        (err) => {
          this.itemPolice = {};
        }
      );
  }

  handleImageError(item) {
    item.image_url = "assets/images/custom/user-ano.jpeg";
  }

  openModalPrestataireReseau() {
    if(!this.itemPolice.reseau_de_soin_id)
      return
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854500,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
 
    let data = {reseau_de_soin_id:this.itemPolice.reseau_de_soin_id,reseau_de_soin_libelle:this.itemPolice.reseau_de_soin_libelle}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
    });
  
  
  }

  ngOnInit() {
    this.getItemsFiliale();
  }

}
